import { Product } from '@/src/types/api-types'
import { ProductsBasket } from '@/type/basket'
import isProductAvailable from '@/lib/isProductAvailable'

const getProductAvailable = (product: Product | ProductsBasket): boolean => {
  return isProductAvailable(product)
}

export default getProductAvailable
